import axios from '@/lib/axios';
import { LensOrderParams } from '../types';

const createCommercialLens = (data: LensOrderParams) => {
  return axios.post('/facility/orders/commercial_lens', data);
}

export default createCommercialLens;